import React, { useState, useRef, useEffect } from 'react';
import Icon from '../AppIcon';

const QuickActionBar = ({ 
  context = 'calendar',
  onActionSelect,
  className = ''
}) => {
  const [isOpen, setIsOpen] = useState(false);
  const menuRef = useRef(null);

  const actions = {
    calendar: [
      {
        id: 'add-activity',
        label: 'Add Activity',
        icon: 'calendar-plus',
        color: '#2563EB'
      },
      {
        id: 'add-event',
        label: 'Add Event',
        icon: 'calendar-check',
        color: '#7C3AED'
      },
      {
        id: 'add-reminder',
        label: 'Add Reminder',
        icon: 'bell-plus',
        color: '#F59E0B'
      }
    ],
    daily: [
      {
        id: 'add-task',
        label: 'Add Task',
        icon: 'list-plus',
        color: '#2563EB'
      },
      {
        id: 'add-time-block',
        label: 'Add Time Block',
        icon: 'clock',
        color: '#10B981'
      },
      {
        id: 'quick-note',
        label: 'Quick Note',
        icon: 'sticky-note',
        color: '#F59E0B'
      }
    ],
    longterm: [
      {
        id: 'add-project',
        label: 'Add Project',
        icon: 'folder-plus',
        color: '#2563EB'
      },
      {
        id: 'add-goal',
        label: 'Add Goal',
        icon: 'target',
        color: '#7C3AED'
      },
      {
        id: 'add-milestone',
        label: 'Add Milestone',
        icon: 'flag',
        color: '#10B981'
      }
    ],
    menu: [
      {
        id: 'add-meal',
        label: 'Add Meal',
        icon: 'utensils',
        color: '#2563EB'
      },
      {
        id: 'add-grocery-item',
        label: 'Add Grocery Item',
        icon: 'shopping-cart',
        color: '#10B981'
      },
      {
        id: 'generate-grocery-list',
        label: 'Generate Grocery List',
        icon: 'list-plus',
        color: '#F59E0B'
      }
    ]
  };

  const currentActions = actions?.[context] || actions?.calendar;

  const handleToggle = () => {
    setIsOpen(!isOpen);
  };

  const handleActionClick = (action) => {
    if (onActionSelect) {
      onActionSelect(action);
    }
    setIsOpen(false);
  };

  useEffect(() => {
    const handleClickOutside = (event) => {
      if (menuRef?.current && !menuRef?.current?.contains(event?.target)) {
        setIsOpen(false);
      }
    };

    const handleEscape = (event) => {
      if (event?.key === 'Escape') {
        setIsOpen(false);
      }
    };

    if (isOpen) {
      document.addEventListener('mousedown', handleClickOutside);
      document.addEventListener('keydown', handleEscape);
    }

    return () => {
      document.removeEventListener('mousedown', handleClickOutside);
      document.removeEventListener('keydown', handleEscape);
    };
  }, [isOpen]);

  return (
    <div 
      className={`quick-action-bar ${className}`}
      ref={menuRef}
      role="menu"
      aria-label="Quick actions"
    >
      {isOpen && (
        <div className="quick-action-bar-menu">
          <div className="quick-action-bar-logo" style={{ padding: '12px 16px', borderBottom: '1px solid rgba(255,255,255,0.1)', marginBottom: '8px', display: 'flex', alignItems: 'center', gap: '8px' }}>
            <img 
              src="/assets/images/ad4cbaf4-dc2b-4059-a1d5-7af12fa38f76_copy-1767800870676.jpg" 
              alt="Starling Family Planner Logo" 
              style={{ width: '20px', height: '20px', objectFit: 'contain' }}
            />
            <span style={{ fontSize: '14px', fontWeight: '600', color: 'white' }}>Starling Family Planner</span>
          </div>
          {currentActions?.map((action) => (
            <button
              key={action?.id}
              className="quick-action-bar-item"
              onClick={() => handleActionClick(action)}
              role="menuitem"
              aria-label={action?.label}
            >
              <Icon 
                name={action?.icon} 
                size={20} 
                color={action?.color}
                className="quick-action-bar-item-icon"
              />
              <span>{action?.label}</span>
            </button>
          ))}
        </div>
      )}
      <button
        className="quick-action-bar-trigger"
        onClick={handleToggle}
        aria-label={isOpen ? 'Close quick actions' : 'Open quick actions'}
        aria-expanded={isOpen}
        aria-haspopup="menu"
      >
        <Icon 
          name={isOpen ? 'x' : 'plus'} 
          size={24} 
          color="currentColor"
        />
      </button>
    </div>
  );
};

export default QuickActionBar;